import { createApp } from '@app/adapters/create-app'

import { SfLog } from '@app/adapters/logger'
import PinnedReports from '@app/application/report/components/pinned-reports.vue'
import type { PinnedReport } from '@app/application/report/types'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='reports/pinned-reports']").each(function () {
    const node = document.getElementById('page-data/reports/pinned-reports')
    if (!node?.textContent) return

    let reports: PinnedReport[]
    try {
      reports = JSON.parse(node.textContent) as PinnedReport[]
    } catch (error) {
      SfLog.error('Failed to parse pinned reports payload', {
        error: error instanceof Error ? error : new Error(String(error)),
      })
      return
    }

    if (reports.length === 0) return

    createApp(PinnedReports, { reports }).mount(this)
  })
})
